import { render, staticRenderFns } from "./DeletePopUp.vue?vue&type=template&id=0c1e5a3a"
import script from "./DeletePopUp.vue?vue&type=script&lang=js"
export * from "./DeletePopUp.vue?vue&type=script&lang=js"
import style0 from "./DeletePopUp.vue?vue&type=style&index=0&id=0c1e5a3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports